import {baseUrl, fetchAndParse, headers} from "./utils";
import {QuestionsQuery} from "../models/Question";
import i18n from "../translations/i18n";

// the questionnaire is the same for every building area and property, so it is loaded once per language
const questionsByLanguage = new Map<string, Promise<QuestionsQuery>>()

export const retrieveQuestions = (): Promise<QuestionsQuery> => {
  const language = i18n.language
  const cached = questionsByLanguage.get(language)
  if (cached) {
    return cached
  }

  const url = new URL(`/questions/?limit=999`, baseUrl);
  const request = fetchAndParse<QuestionsQuery>(url.toString(), {
    method: "GET",
    headers: {
      ...headers,
      'Accept-Language': language,
    }
  })
  // a failed request is not cached, so the next call tries again
  request.catch(() => questionsByLanguage.delete(language))
  questionsByLanguage.set(language, request)
  return request
}
